import {connect} from 'react-redux';

import {createSelector, makeMapStateToProps} from '../../../../srcCommon/helpers/reselectHelpers';
import {makeGetContactDetailsPanel} from '../../../store/panels/contacts/contactDetailsPanelSelectors';
import {ContactDetailsPanelId} from '../../../store/panels/panelStateBase';
import {ContactsSection} from './contactsSection';

/*
 * Props.
 */

interface ContactsSectionContainerProps {
  panelId: ContactDetailsPanelId;
}

/*
 * Selectors.
 */

function makeGetContactDetailsPanelLocation() {
  return createSelector([makeGetContactDetailsPanel()], (panel) => panel?.location);
}

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps<ContactsSectionContainerProps>()(() => ({
  location: makeGetContactDetailsPanelLocation(),
}));

export const ContactsSectionContainer = connect(mapStateToProps)(ContactsSection);
